export class FetchingConfigError extends Error {
  constructor(service: "viewer" | "widget") {
    super(`Error while fetching product config for ${service}`);
    this.name = "FetchingConfigError";
  }
}
